<template>
  <generic-modal :title="$t('scheduled execution')" ref="generic_modal">
    <div>
      <div class="title is-5">{{ script.name }}</div>
      <div
        class="subtitle is-6"
        v-if="script.arguments && script.arguments.length"
      >
        {{ $t("enter arguments value") }}
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_active"
              v-model="meta.is_active"
            />
            <label for="chk_is_active">{{ $t("is active") }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("cron expression") }}</label>
            <input class="input" type="text" v-model="meta.cron_expression" />
            <div class="subtitle is-5 pt-3">{{ cron_translation }}</div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_send_email"
              v-model="meta.settings.send_email_on_finish"
            />
            <label for="chk_send_email">{{ $t("send email on finish") }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <input class="input" type="text" v-model="meta.settings.email" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('outbox template')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/outbox/template/catalog"
              name_field="name"
              value_field="template_id"
              @selected="outbox_template_changed"
              ref="outbox_template_dropdown"
            />
          </div>
        </div>
      </div>
      <!-- <pre>{{ script }}</pre> -->
      <article
        class="message is-warning"
        v-if="!script.arguments || !script.arguments.length"
      >
        <div class="message-body">
          {{ $t("this script does not require any arguments") }}
        </div>
      </article>
      <div class="field" v-for="arg in script.arguments" :key="arg.name">
        <label class="label">{{ arg.name }}</label>
        <input class="input" type="text" v-model="args[arg.name]" />
      </div>
    </div>
    <div v-if="result" class="pt-5">
      <div class="title is-5 mb-2">{{ $t("execution result") }}</div>
      <pre>{{ result }}</pre>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  del,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import cronstrue from "cronstrue";

export default {
  name: "ExecuteModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      script: {},
      error: "",
      args: {},
      meta: {
        settings: {},
      },
      result: undefined,
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.cron_expression /* || !v.meta.sale_price */;
    },
    cron_translation() {
      let v = this;
      if (v.meta.cron_expression) {
        try {
          return cronstrue.toString(v.meta.cron_expression);
        } catch (error) {
          console.error(error);
          return "";
        }
      } else return "";
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(script) {
      let v = this;
      v.set_initial_state();
      v.script = script;
      let args = script.arguments || [];
      v.args = args.reduce((acc, arg) => {
        acc[arg.name] = "";
        return acc;
      }, {});

      get("/script", { directory: script.directory })
        .then((rspns) => {
          if (rspns && rspns.schedule) {
            v.meta.cron_expression = rspns.schedule;
            v.meta.is_active = rspns.is_active;
            v.meta.uuid = rspns.uuid;
            v.args = rspns.arguments;
            if (rspns.settings) {
              v.meta.settings = rspns.settings;
              if (v.meta.settings.outbox_template_id) {
                v.$refs.outbox_template_dropdown.set_value(
                  v.meta.settings.outbox_template_id
                );
              }
            }
          }
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      post("/script", {
        directory: v.script.directory,
        args: v.args,
        schedule: v.meta.cron_expression,
        is_active: v.meta.is_active,
        settings: v.meta.settings,
      })
        .then((rspns) => {
          v.result = rspns;
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.script = {};
      v.error = "";
      v.result = undefined;
      v.args = {};
      v.meta = {
        cron_expression: "",
        is_active: true,
        settings: {},
      };
      v.$refs.outbox_template_dropdown.clear();
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete scheduled execution?"),
        v,
        () => {
          del("/script", { uuid: v.meta.uuid })
            .then(() => {
              v.close_modal();
              v.$emit("success");
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    outbox_template_changed(template) {
      let v = this;
      if (template) v.meta.settings.outbox_template_id = template.template_id;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
